export const SET_TOKEN = 'SET_TOKEN'
export const RESET_LOGIN = 'RESET_LOGIN'
export const SET_COMPONENTS = 'SET_COMPONENTS'
export const SET_VEHICLE = 'SET_VEHICLE'
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'
export const SET_VIN = 'SET_VIN'

export const SESSION_TOKEN_NAME = 'alldata/token'
export const SESSION_PROFILE = 'alldata/profile'



// WEBPACK FOOTER //
// ./src/store/modules/alldata/types.js